import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertTitleList } from '@/common/converter/convert-title-list'
import { convertCellEvent } from '@/common/converter/convert-cell-event'
import {
  snakeToCamel,
  snakeToCamelTemplateLiterals
} from '@/common/converter/utils/snake-to-camel'

/**
 * convert to legacy cell item format
 * 콘텍스트 프로퍼티와, 이벤트 리스트를 가진 데이터를 구형 셀 아이템으로 변환
 * @param context
 * @returns {{age_tag: string, thumbnail: string, alt: string, update_taglist: (string[]|*[]), event_list: {bodylist: *, url: string}[], title_list: unknown[], progress: (*|string), rank: ((function(): *)|string|*), time: string, force_refresh: string, brand_taglist: *[], bottom_taglist: *[], top_taglist: (string[]|*[]), age: (*|string)}}
 */
export const convertCell = (context = {}) => {
  const { contextProperty = {}, eventList = [] } = context
  const thumbnail = snakeToCamel(contextProperty?.image?.thumbnail) ?? ''
  const alt = snakeToCamel(contextProperty?.alt) ?? ''
  const titleList =
    contextProperty?.titleList.map(snakeToCamelTemplateLiterals) ?? []
  const brandTagList = contextProperty?.tag?.brandList ?? []
  const topTagList = contextProperty?.tag?.topList ?? []
  const updateTagList = contextProperty?.tag?.updateList ?? []
  const bottomTagList = contextProperty?.tag?.bottomList ?? []
  const rank = snakeToCamel(contextProperty?.rank?.order) ?? ''

  return {
    thumbnail: replacePlaceholder(thumbnail, context),
    alt: replacePlaceholder(alt, context),
    force_refresh: '',
    top_taglist:
      topTagList.map((tag) => replacePlaceholder(tag, context)) ?? [],
    brand_taglist: brandTagList.map((tag) => replacePlaceholder(tag, context)),
    age: context?.personal?.targetAge ?? '',
    age_tag: '',
    bottom_taglist: bottomTagList.map((tag) =>
      replacePlaceholder(tag, context)
    ),
    update_taglist:
      updateTagList.map((tag) => replacePlaceholder(tag, context)) ?? [],
    time: context?.personal?.remainMinute ?? '',
    progress: context?.personal?.viewratio ?? '',
    rank: replacePlaceholder(rank, context) ?? '',
    title_list: titleList.map(
      (title) => convertTitleList(replacePlaceholder(title, context)) ?? []
    ),
    event_list: eventList.map((event) => convertCellEvent(event, context))
  }
}
